import { parsePhoneNumberFromString } from 'libphonenumber-js';
import i18n from '../i18n';

export interface PhoneValidationResult {
  isValid: boolean;
  error: string | null;
  normalizedPhone: string;
}

export const validatePhone = (phone: string): PhoneValidationResult => {
  const trimmed = phone.trim();

  if (!trimmed) {
    return {
      isValid: false,
      error: i18n.t('phoneValidation.required'),
      normalizedPhone: '',
    };
  }

  // Wartość null oznacza że pole jest puste (komponent zwraca null dla pustego inputu)
  if (trimmed === 'null' || !trimmed.startsWith('+')) {
    return {
      isValid: false,
      error: i18n.t('phoneValidation.required'),
      normalizedPhone: '',
    };
  }

  const phoneNumber = parsePhoneNumberFromString(trimmed);

  if (!phoneNumber) {
    return {
      isValid: false,
      error: i18n.t('phoneValidation.invalidFormat'),
      normalizedPhone: trimmed,
    };
  }

  if (!phoneNumber.isValid()) {
    const nationalNumber = phoneNumber.nationalNumber;

    if (nationalNumber.length < 6) {
      return {
        isValid: false,
        error: i18n.t('phoneValidation.tooShort'),
        normalizedPhone: trimmed,
      };
    }

    if (nationalNumber.length > 15) {
      return {
        isValid: false,
        error: i18n.t('phoneValidation.tooLong'),
        normalizedPhone: trimmed,
      };
    }

    return {
      isValid: false,
      error: i18n.t('phoneValidation.invalid'),
      normalizedPhone: trimmed,
    };
  }

  return {
    isValid: true,
    error: null,
    normalizedPhone: phoneNumber.number,
  };
};
